import { IPdfsLinksState } from '../../App/interfaces/IPdfsLinksState';

export const pdfsLinksInitialState = (): IPdfsLinksState => {
    const state: IPdfsLinksState = {
        allMenuPdfUrls: {},
    };
    return state;
};